module.exports = __webpack_public_path__ + "static/media/art10.dc446420.png";